import React, { useState, useEffect, useMemo } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import QRCode from "react-qr-code";
import '../Css/OrderLabel.css';
import Logger from "./Logger";
import { getLoggerBaseURL } from '../utils/getLoggerBaseURL';

function OrderLabel({ orders = [], selectedOrder = null, onClose }) {
    const userEmail = sessionStorage.getItem('userEmail');

    const [qrLinks, setQrLinks] = useState({});

    // Initialize Logger
    const logger = useMemo(() => new Logger(getLoggerBaseURL()), []);

    useEffect(() => {
        // Function to send data to API and get QR code links
        const generateQrLinks = async () => {
            const orderIds = (orders.length > 0 ? orders : selectedOrder ? [selectedOrder] : []).map(order => order._id);
            if (!userEmail || orderIds.length === 0) return;

            try {
                const orderIdsString = `[${orderIds.join(",")}]`;
                const response = await fetch(`/api/DrOrder/addQrData`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        adminEmail: userEmail,
                        orderIds: orderIdsString,
                    }),
                });

                const data = await response.json();
                if (data || data.id) {
                    setQrLinks(data.id);
                }
            } catch (error) {
                logger.log(`Error generating QR link: ${error.message}`, 'ERROR');
            }
        };

        generateQrLinks();
    }, [orders, selectedOrder, userEmail, logger]);

    const handlePrint = () => {
        // Determine if we are printing multiple orders or a single order
        const printContent = document.querySelectorAll('.label-containerQR');

        // Open a new print window
        const WindowPrt = window.open('', '', 'width=800,height=600');

        // Write the styles to the print window, defining dimensions for the label
        WindowPrt.document.write('<html><head><title>Print</title><style>');
        WindowPrt.document.write(`
            @media print {
                body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                    padding: 0;
                    font-size: 12px;
                    line-height: 1.5;
                }
                .label-containerQR {
                    width: 2in; /* Set the width of the label */
                    height: 3in; /* Set the height of the label */
                    padding: 10px;
                    margin: 0;
                    border: 1px solid #000;
                    box-sizing: border-box;
                    page-break-after: always;
                }
                .label-sectionQR {
                    margin-bottom: 10px;
                }
                .qr-code {
                    text-align: center;
                    margin-bottom: 10px;
                }
                .to-address {
                    font-size: 12px;
                    line-height: 1.5;
                }
                .label-containerQR p {
                    margin: 0;
                    padding: 0;
                }
            }
        `);
        WindowPrt.document.write('</style></head><body>');

        // Iterate over the selected elements and add their HTML to the print window, wrapping each label in a container
        printContent.forEach(label => {
            WindowPrt.document.write(`<div>${label.outerHTML}</div>`);
        });

        // Finalize and trigger the print
        WindowPrt.document.write('</body></html>');
        WindowPrt.document.close();
        WindowPrt.focus();
        WindowPrt.print();
        WindowPrt.close();
    };

    // Determine which orders to display
    const labelsToDisplay = orders.length > 0 ? orders : (selectedOrder ? [selectedOrder] : []);

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle className='spaceForQRHeadingAndButton'>
                QR Code Labels
                <button className="printQR" onClick={handlePrint}>Print</button>
            </DialogTitle>
            <DialogContent>
                {labelsToDisplay.map(order => {
                    return (
                        <div key={order._id} className="label-containerQR">
                            <div className="label-sectionQR details">
                                <p><b>Order No:</b> {order.Order_No}</p>
                                <p><b>Deliver by:</b> {order.Del_Time}</p>
                                <p><b>Amount:</b> {order.amount}</p>
                            </div>
                            <div className="label-sectionQR qr-code">
                                <QRCode value={qrLinks} size={100} />
                            </div>
                            <div className="label-sectionQR to-address">
                                <p><b>To:</b> {order.Rec_Name}</p>
                                <p><b>Address:</b> {order.Rec_Add}</p>
                            </div>
                        </div>
                    );
                })}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default OrderLabel;
